module.exports = __webpack_public_path__ + "media/images/spido-0c4ecb998de1a61c79fa7394025e1501.png";